"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var filters_1 = require("@/filter/filters");
var rurallure_ts_trip_edition_1 = require("rurallure-ts-trip-edition");
var PointOfInterestTimeLine_vue_1 = __importDefault(require("@/components/point-of-interest/time-line/PointOfInterestTimeLine.vue"));
var LocalityTimeLine_vue_1 = __importDefault(require("@/components/locality/time-line/LocalityTimeLine.vue"));
var vue_1 = __importDefault(require("vue"));
var PointOfInterestListSelection_vue_1 = __importDefault(require("@/components/point-of-interest/list-selection/PointOfInterestListSelection.vue"));
var TimeLine = /** @class */ (function (_super) {
    __extends(TimeLine, _super);
    function TimeLine() {
        var _this = _super.call(this) || this;
        _this.loader = true;
        _this.showAlternativeSelectionErrorMessage = false;
        _this.tripEditor = new rurallure_ts_trip_edition_1.TripEditor(_this.route, _this.plannerRouteDataForChanges, _this.$i18n.locale, _this.startDate, _this.endDate, _this.localities);
        return _this;
    }
    TimeLine.prototype.mounted = function () {
        for (var _i = 0, _a = this.plannerRouteDataForChanges.alternative_pois; _i < _a.length; _i++) {
            var poiData = _a[_i];
            this.tripEditor.alternativePointsOfInterest.push({ id: poiData.id });
        }
        this.tripEditor.init();
        this.loader = false;
    };
    TimeLine.prototype.restore = function () {
        this.tripEditor.restore();
        this.updatePropsFromTripEditor();
        this.$forceUpdate();
    };
    TimeLine.prototype.updatePropsFromTripEditor = function () {
        this.route = this.tripEditor.route;
        this.plannerRouteDataForChanges = this.tripEditor.routeDataForChanges;
        this.localities = this.tripEditor.localities;
    };
    TimeLine.prototype.onHideAlternativeSelectionModal = function () {
        this.showAlternativeSelectionErrorMessage = false;
    };
    TimeLine.prototype.selectAlternativePointOfInterest = function (pointOfInterest) {
        this.showAlternativeSelectionErrorMessage = false;
        if (this.tripEditor.selectAlternativePointOfInterest(pointOfInterest)) {
            this.$bvModal.hide('add-point-of-interest-modal');
            this.$forceUpdate();
        }
        else {
            this.showAlternativeSelectionErrorMessage = true;
        }
    };
    TimeLine.prototype.deleteRoutePointOfInterest = function (routePointOfInterest) {
        this.tripEditor.deleteRoutePointOfInterest(routePointOfInterest);
        this.$forceUpdate();
    };
    TimeLine.prototype.hydrateRoutePois = function () {
        return __awaiter(this, void 0, Promise, function () {
            var requestBody, _i, _a, routePointOfInterest;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestBody = [];
                        for (_i = 0, _a = this.tripEditor.route.route_points_of_interest; _i < _a.length; _i++) {
                            routePointOfInterest = _a[_i];
                            if (Object.keys(routePointOfInterest.point_of_interest).length === 1) {
                                requestBody.push(routePointOfInterest.point_of_interest.id);
                            }
                        }
                        return [4 /*yield*/, this.$getListPointOfInterest.request(requestBody).then(function (response) {
                                _this.tripEditor.routeHydrate(response);
                                _this.updatePropsFromTripEditor();
                                _this.loader = false;
                            }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TimeLine.prototype, "route", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], TimeLine.prototype, "transport", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, default: false })
    ], TimeLine.prototype, "onlyRead", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, default: true })
    ], TimeLine.prototype, "fetchPointOfInterestData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, default: function () {
                return {
                    alternative_pois: [],
                    planned_pois: []
                };
            } })
    ], TimeLine.prototype, "plannerRouteDataForChanges", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, default: null })
    ], TimeLine.prototype, "startDate", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, default: null })
    ], TimeLine.prototype, "endDate", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, default: null })
    ], TimeLine.prototype, "localities", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: false, default: false })
    ], TimeLine.prototype, "hideHours", void 0);
    TimeLine = __decorate([
        vue_property_decorator_1.Component({
            name: 'TimeLine',
            components: {
                LocalityTimeLine: LocalityTimeLine_vue_1.default,
                PointOfInterestTimeLine: PointOfInterestTimeLine_vue_1.default,
                PointOfInterestListSelection: PointOfInterestListSelection_vue_1.default
            },
            filters: {
                timeFormat: filters_1.timeFormat
            }
        })
    ], TimeLine);
    return TimeLine;
}(vue_1.default));
exports.default = TimeLine;
